import { useState, useEffect } from 'react';
import { throttle } from '../domain/utils/throttle';
import { debounce } from '../domain/utils/debounce';

const getScrollCoordinates = (useWindow, ref) => {
  let x = 0;
  let y = 0;
  if (useWindow && typeof window !== 'undefined') {
    x = window.scrollX;
    y = window.scrollY;
  }
  if (!useWindow && ref && ref.current) {
    x = ref.current.scrollLeft;
    y = ref.current.scrollTop;
  }
  return { x, y };
};

export const useScrollCoordinates = ({
  useWindow = false,
  ref = undefined,
  throttleWait = 0,
  debounceWait = 0
} = {}) => {
  const [scrollCoordinates, setScrollCoordinates] = useState(() =>
    getScrollCoordinates(useWindow, ref)
  );

  const handleEventRaw = () => {
    setScrollCoordinates(getScrollCoordinates(useWindow, ref));
  };

  let handleEvent = handleEventRaw;
  if (throttleWait) {
    handleEvent = throttle(handleEventRaw, throttleWait);
  }
  if (debounceWait) {
    handleEvent = debounce(handleEventRaw, debounceWait, false);
  }

  useEffect(() => {
    if (useWindow) {
      window.addEventListener('scroll', handleEvent, {
        passive: true
      });
      window.addEventListener('resize', handleEvent, {
        passive: true
      });
    }
    if (!useWindow && ref && ref.current) {
      ref.current.addEventListener('scroll', handleEvent, {
        passive: true
      });
      // Listening to a resize event would make sense if element's scroll is
      // affected by window size, which is something that doesn't happen yet.
      // Hence, we comment next line out to avoid one re-render.
      // window.addEventListener('resize', handleEvent, {
      //   passive: true
      // });
    }
    return () => {
      if (useWindow) {
        window.removeEventListener('scroll', handleEvent, {
          passive: true
        });
        window.removeEventListener('resize', handleEvent, {
          passive: true
        });
      }
      if (!useWindow && ref && ref.current) {
        ref.current.removeEventListener('scroll', handleEvent, {
          passive: true
        });
        // window.removeEventListener('resize', handleEvent, {
        //   passive: true
        // });
      }
    };
  }, []);

  return scrollCoordinates;
};
